import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addSymptom({ dispatch, commit }, symptom) {
    try {
      const { data } = await request.post('/symptoms', symptom);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
